import { useFormField } from '@calendly/form';
import { Loader } from '@calendly/ui/components/loader';
import { useCalendarData } from '@calendly/ui/hooks/use-calendar-data';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { useState } from 'react';
import Calendar from 'components/availability/form/calendar_view/calendar';
import Navigation from 'components/availability/form/calendar_view/navigation';
import TimezonePicker from 'components/availability/form/timezone_picker';
import { useHolidays } from './use_holidays';
import { useUpdateAvailabilityUserHolidaySetV4Mutation } from '../../api';
const calendarContainerCss = "c1iqutcz";
const headerWithinModalCss = "h35o9yg";
const headerCss = "hsv4whi";
export const CalendarView = ({
  withinModal,
  menuLayerStyle
}) => {
  const [updateHolidaySet] = useUpdateAvailabilityUserHolidaySetV4Mutation();
  const [{
    value: days
  }, _meta, {
    setValue: setDays
  }] = useFormField({
    name: 'days'
  });
  const [{
    value: dates
  }, _meta2, {
    setValue: setDates
  }] = useFormField({
    name: 'activeDates'
  });
  const [{
    value: timezone
  }, _meta3, {
    setValue: setTimezone
  }] = useFormField({
    name: 'timezone'
  });
  const now = moment().tz(timezone).format('YYYY-MM');
  const [currentMonthId, setCurrentMonthId] = useState(now);
  const [holidays, uuid, isLoading] = useHolidays();
  const {
    title,
    weekdays,
    weeks,
    nextMonthId,
    prevMonthId,
    isCurrentMonth
  } = useCalendarData(currentMonthId, timezone);
  const setWdayIntervals = (wday, newIntervals) => {
    const newDay = {
      ...days,
      [wday]: newIntervals
    };
    setDays(newDay);
  };
  const updateHolidays = updatedHolidays => updateHolidaySet({
    uuid,
    holidays: updatedHolidays,
    redirect: false
  });
  if (isLoading) return <Loader />;
  return <>
      <div className={classNames(headerCss, {
      [headerWithinModalCss]: withinModal
    })}>
        <Navigation isCurrentMonth={isCurrentMonth} setMonth={setCurrentMonthId} prevMonthId={prevMonthId} nextMonthId={nextMonthId} title={title} useUpdatedStyles alternateStyling />
        <TimezonePicker aria-labelledby="timezone-title" timezone={timezone} onSelectTimezone={setTimezone} rightAligned alternateStyling menuLayerStyle={menuLayerStyle} />
      </div>
      <div className={calendarContainerCss}>
        <Calendar days={days} dates={dates} holidays={holidays} timezone={timezone} weekdays={weekdays} weeks={weeks} setDates={setDates} setWdayIntervals={setWdayIntervals} setHolidays={updateHolidays} activeWeekends useUpdatedStyles isV4AvailabilityPage />
      </div>
    </>;
};

require("./calendar_view.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./calendar_view.js");